import { Injectable, ViewContainerRef } from '@angular/core';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { CaptureModalComponent } from './capture-modal.component';
import { overlayConfigFactory } from 'ngx-modialog';

@Injectable()
export class CaptureModalService {
    constructor(public modal: Modal) {}

    openDialog(uploader: any, viewContainer:ViewContainerRef) {
    	(this.modal.overlay as any).defaultViewContainer = viewContainer;
        return this.modal.open(CaptureModalComponent, overlayConfigFactory({uploader: uploader}, BSModalContext));
    };
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/capture-modal/capture-modal.service.ts